import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, map, Observable, throwError } from "rxjs";
import {
  OrderRequestDto,
  PayOrderRequestDto} from "../dto/request/order-request-dto";
import { environment } from "src/environments/environment";
import {
  OrderBillingResponseDto,
  OrderDataResponseDto,
  OrderResponseDto} from "../dto/response/order-response-dto";
import { CheckoutResponseDto } from "../dto/response/checkout-response-dto";

@Injectable({
  providedIn: "root"})
export class OrderService {
  constructor(private _httpClient: HttpClient) {}

  getOrders(page: number, pageSize: number): Observable<OrderResponseDto> {
    return this._httpClient.get<OrderResponseDto>(
      `${environment.backend}/orders?page=${page}&pageSize=${pageSize}`,
    );
  }

  getOrder(orderId: string): Observable<OrderDataResponseDto> {
    return this._httpClient.get<OrderDataResponseDto>(
      `${environment.backend}/orders/${orderId}`,
    );
  }

  createOrder(
    request: OrderRequestDto,
    turnstileToken: string,
  ): Observable<CheckoutResponseDto> {
    return this._httpClient
      .post<CheckoutResponseDto>(
        `${environment.backend}/orders`,
        { ...request },
        {
          headers: {
            "X-Turnstile-Token": turnstileToken}},
      )
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          return throwError(() => error);
        }),
      );
  }

  payOrder(
    orderId: string,
    request: PayOrderRequestDto,
  ): Observable<OrderDataResponseDto> {
    return this._httpClient.post<OrderDataResponseDto>(
      `${environment.backend}/orders/${orderId}/retry`,
      request,
    );
  }

  getOrderBilling(orderId: string): Observable<OrderBillingResponseDto> {
    return this._httpClient.get<OrderBillingResponseDto>(
      `${environment.backend}/order-billings/${orderId}`,
    );
  }

  cancelOrder(orderId: string, reason: string): Observable<void> {
    return this._httpClient.post<void>(`${environment.backend}/order-cancel`, {
      orderId,
      reason});
  }

  getOrderCancellation(orderId: string): Observable<any> {
    return this._httpClient.get<any>(
      `${environment.backend}/order-cancel/${orderId}`,
    );
  }
}
